import { render, staticRenderFns } from "./SitemapControl.vue?vue&type=template&id=8e8821b0&scoped=true"
import script from "./SitemapControl.vue?vue&type=script&lang=js"
export * from "./SitemapControl.vue?vue&type=script&lang=js"
import style0 from "./SitemapControl.vue?vue&type=style&index=0&id=8e8821b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8821b0",
  null
  
)

export default component.exports